module.exports = __webpack_public_path__ + "img/videocam.6e6f286a.svg";